import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { HeightType } from '@com-delta-idp/mnx-ui-kit';
import {
  ApplyOfferResponse,
  OfferModalConfig,
  PartnerContentModal
} from '../../pages/fast-action-banner-page/models/partner-content-modal.interfaces';

@Component({
  selector: 'idp-partner-content-modal',
  templateUrl: './partner-content-modal.component.html',
  styleUrls: ['./partner-content-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PartnerContentModalComponent
  implements OnInit, PartnerContentModal
{
  @Input() values: ApplyOfferResponse = {} as ApplyOfferResponse;
  @Input() config: OfferModalConfig = {} as OfferModalConfig;
  @Input() openModal = false;
  @Input() skymilesNumber = '';

  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  height: HeightType = 'full';
  partnerDataForm!: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.setPartnerModalParams();
  }

  setPartnerModalParams() {
    if (this.values !== undefined) {
      // Do not update form params, as these are set by amex. Any change in params will break the functionality.
      this.partnerDataForm = this.formBuilder.group({
        acq_experience: new UntypedFormControl(this.values.acqExperience),
        partner_page_name: new UntypedFormControl(this.config.postPage),
        return_url: new UntypedFormControl(this.config.returnUrl),
        applicant_request_token: new UntypedFormControl(
          this.values.applicantRequestToken
        ),
        acquisition_offer_id: new UntypedFormControl(
          this.values.acquisitionOfferId
        ),
        delta_enrollment_id: new UntypedFormControl(this.skymilesNumber),
        channel: new UntypedFormControl(this.config.channel),
        card_type: new UntypedFormControl(this.config.card)
      });
      if (this.values.acquisitionWebToken) {
        this.partnerDataForm.addControl(
          'acquisition_web_token',
          new UntypedFormControl(this.values.acquisitionWebToken)
        );
      }
      setTimeout(() => {
        this.submitToPartner();
      }, 100);
    }
  }

  closeModalHandler() {
    this.openModal = false;
    this.closeModal.emit(this.openModal);
  }

  submitToPartner() {
    const partnerModalBody =
      this.elementRef.nativeElement.querySelector('#partnerModalBody');
    const partnerForm =
      this.elementRef.nativeElement.querySelector('#partnerForm');

    for (const key in this.partnerDataForm.controls) {
      if (this.partnerDataForm.controls[key]) {
        const partnerDataField =
          this.elementRef.nativeElement.ownerDocument.createElement('input');
        partnerDataField.setAttribute('type', 'hidden');
        partnerDataField.value = JSON.stringify(
          this.partnerDataForm.controls[key].value
        ).replace(/"/g, '');
        partnerDataField.name = key;
        partnerForm.appendChild(partnerDataField);
      }
    }
    partnerForm.style.display = 'none';
    partnerModalBody.appendChild(partnerForm);
    partnerForm.submit();
  }

  /**
   * To set focus on close button on tab from last focusable element inside iframe.
   * This keep the tab cycle and keep the focus inside of the iframe
   */
  setFocusOnCloseBtn() {
    this.elementRef.nativeElement.querySelector('.idp_dialog__close').focus();
  }
}
